import { ChangeEvent } from "react";
import { FormControlModel } from "types";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "../atoms/TextField";
import { useField } from "formik";
import get from "lodash/get";

const TextFieldAdormentForm = ({
  questionData,
  name,
  type,
  label,
  formik,
  disabled,
  onBlurCallback,
  visible = true,
  adormentSymbol = "$",
}: FormControlModel) => {
  const [field, meta] = useField(name);

  if (!questionData) return <></>;

  return visible ? (
    <TextField
      type={type}
      name={name}
      label={label}
      margin='normal'
      disabled={disabled}
      id={questionData.id}
      value={formik.values[name]?.value || ""}
      InputProps={{
        startAdornment: <InputAdornment position='start'>{adormentSymbol}</InputAdornment>,
      }}
      onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
        formik.setFieldValue(name, {
          value: target.value,
          questionID: questionData.id,
        });
      }}
      onBlur={(e: ChangeEvent<HTMLInputElement>) => {
        if (onBlurCallback && typeof onBlurCallback === "function") onBlurCallback(e.target.value as string);
      }}
      error={meta.touched && Boolean(get(meta.error, "value"))}
      helperText={meta.touched && get(meta.error, "value")}
    />
  ) : null;
};

export default TextFieldAdormentForm;
